module.exports = __webpack_public_path__ + "img/franciscobeltrao-black.4ac1d30c.png";